export { default } from "./teacher";
